import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import MobileSvg from "../../../assets/images/Cross-platform-Mobile-Apps.webp";
import WebSvg from "../../../assets/images/web-application-compatible-on-multiple-devcies.webp";
import NativeSvg from "../../../assets/images/concept-sketch-of-a-native-app.webp";
import IoTSvg from "../../../assets/images/representation-of-internet-of-things.webp";
import DigitalMarketingSvg from "../../../assets/images/celebrating-growth-and-profits-with-marketeer.webp";
import CMSSvg from "../../../assets/images/adding-widget-on-a-CMS.webp";
import "./style.css";
import { routes } from "../../../config/utilities/utils.constant";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function SliderComponent({ title }) {
  const experties = [
    { 
      title: "Cross-Platform Mobile App Development",
      description:
        "Build iOS & Android apps with a single code-base, using cross-platform frameworks such as React Native or Flutter. We help you achieve native performance at greatly reduced development costs.",
      btnText: "Explore Cross-platform App Solutions",
      image: MobileSvg,
      pageLink: routes.CROSSPLATFORMMOBILEAPPDEVELOPMENT,
      imgAlt:
        "Two people using a cross-platform mobile application on two different mobile devices having different OS platforms.",
    },
    {
      title: "Web Application Development",
      description:
        "We build robust browser-based applications that deliver flawless performance across all devices, with full support for dynamic content and complex functionalities.",
      btnText: "Explore Web App Solutions",
      image: WebSvg,
      pageLink: routes.WEBAPPS,
      imgAlt:
        "A user viewing the same web application on desktop, laptop and mobile phone as they’re designed for all these devices.",
    },
    {
      title: "Native Mobile App Development",
      description:
        "We develop dedicated, fully optimized applications for both iOS and Android devices. Native apps ensure maximum performance, hardware compatibility, and superior user experience.",
      btnText: "Explore Native App Solutions",
      image: NativeSvg,
      pageLink: routes.NATIVEAPPDEVELOPMENT,
      imgAlt:
        "A native mobile application with many features and efficient hardware utilization.",
    },
    {
      title: "IoT  Development",
      description:
        "We engineer custom IoT solutions with embedded firmware, real-time data pipelines, data processing, sophisticated decision-making, remote management, automation and robust cloud integration.",
      btnText: "Explore IoT  Solutions",
      image: IoTSvg,
      pageLink: routes.IOTDEVELOPMENTSERVICE,
      imgAlt:
        "Applications of Internet of things in various industries, devices and use-cases.",
    },
    {
      title: "CMS Development",
      description:
        "Launch user-friendly CMS sites quickly and effortlessly. Whether you need an informational site or a full e-commerce store, we build your online presence to grow alongside your business.",
      btnText: "Explore CMS Solutions",
      image: CMSSvg,
      pageLink: routes.CMSDEVELOPMENT,
      imgAlt:
        "A person easily placing a widget on a CMS-based website with other objects such as images and navigation.",
    },
    {
      title: "Digital Marketing",
      description:
        "Every marketing plan begins with data-driven research tailored to your business's unique needs and dynamics. We treat each project as an adventure and an opportunity to demonstrate our strategic precision.",
      btnText: "Explore Digital Marketing Solutions",
      image: DigitalMarketingSvg,
      pageLink: routes.DIGITALMARKETING,
      imgAlt:
        "Marketeer celebrating growth, profits and success in business KPIs with stakeholder.",
    },
  ];

  return (
    <div className="space-y-10 ">
      <div className="space-y-3">
        <motion.h2
          className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[40px] 2xl:text-[40px]  font-bold capitalize text-center text-dark font-butler"
          initial={{ opacity: 0, y: 40 }} // start hidden + slightly lower
          whileInView={{ opacity: 1, y: 0 }} // animate when visible
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.3 }} // trigger once when 30% visible
        >
          <span className="inline md:block">
            {" "}
            Accelerate your business with{" "}
          </span>
          <span className="inline md:block">
            perfectly-fitting digital solutions.
          </span>
        </motion.h2>
      </div>
      <Swiper
        spaceBetween={20}
        centeredSlides={true}
        navigation={true}
        modules={[Navigation, Autoplay]}
        autoplay={{
          delay: 3000, // Change slide every 3 seconds
          disableOnInteraction: false, // Keeps autoplay active after user interaction
        }}
        className="mySwiper2"
      >
        {experties.map((element, index) => (
          <SwiperSlide key={index}>
            <div className="h[50rem]  md:h-[25rem]   w-full  flex flex-col justify-center items-center relative overflow-hidden shadowlg rounded-lg ">
              <div className="  flex flex-col md:flex-row justify-center items-center space-y-10 md:space-y-0  md:space-x-10 ">
                <div className="w-full md:w-5/12  ">
                  <img
                    src={element.image}
                    alt={element.imgAlt}
                    className={` ${
                      index === 0
                        ? "w-[10rem] md:w-[14rem]"
                        : "w-[16rem] md:w-[18rem]"
                    } mx-auto`}
                    loading="lazy"
                       width="640px"
                    height="360px"
                  />
                </div>

                <div className="flex flex-col  items-end justify-center  font-bold  text-2xl lg:text-4xl w-full md:w-7/12 ">
                  <div className="space-y-4 md:space-y-3">
                    <h3 className="capitalize text-dark">{element.title}</h3>
                    <p className="text-base leading-[1.625rem] font-normal text-gray-600">
                      {element.description}
                    </p>

                    <Link
                      to={element.pageLink}
                      className="mt-4 inline-block text-center px-2 md:px-6 py-3 bg-[#FFC067] text-dark font-bold rounded shadow hover:bg-[#DF73FF] text-base transition ease-in duration-300"
                      aria-label={`Internal link to ${element.title} page`}
                    >
                      {element.btnText}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default SliderComponent;
